import TableHeaderRow from "../../ui/TableHeaderRow"
import TableHeader from "../../ui/TableHeader"
import SortHeader from "../sorting/SortHeader"
import { Link, useNavigate } from "react-router-dom"
import React from "react"
import Table, { Row, Cell } from "../../ui/Table"
import PropTypes from "prop-types"
import DropDownFilter from "../filters/DropDownFilter"
import { useSelector } from "react-redux"
import { selectAstrositesById } from "../astrosites/slice"
import DateTimeFilter from "../filters/DateTimeFilter"
import Timestamp from "../../ui/Timestamp"
import IDCopy from "../../ui/IDCopy"
import { selectAdvancedMode } from "../settings/slice"
import AstrositeName from "../astrosites/AstrositeName"

/**
 * SchedulesTable renders a given list of schedules
 * @param schedules
 * @param filter If provided will be used to power the filters if not filters will not be shown
 * @param setFilter
 * @returns {JSX.Element}
 * @constructor
 */
const SchedulesTable = ({ schedules = [], filter, setFilter }) => {
  const astrositesByIds = useSelector(selectAstrositesById)
  // User setting to show more details such as id's
  const advancedModeState = useSelector(selectAdvancedMode)
  // if filters apply to advancedMode columns we have to show them
  const advancedModeOverride = filter?.id_cnts ? true : false
  const advancedMode = advancedModeOverride
    ? advancedModeOverride
    : advancedModeState
  const navigate = useNavigate()
  const navigateTo = (id) => () => navigate(`/schedules/${id}`)

  return (
    <Table>
      <TableHeaderRow sticky>
        <TableHeader
          filterControl={
            filter && (
              <DateTimeFilter
                filter={filter}
                setFilter={setFilter}
                active={filter.from || filter.to ? true : false}
              />
            )
          }
          sortControl={
            filter && (
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"created"}
              />
            )
          }
        >
          Date & Time
        </TableHeader>
        <TableHeader
          filterControl={
            filter && (
              <DropDownFilter
                values={Object.keys(astrositesByIds).map((a) => ({
                  name: a,
                  value: a,
                }))}
                filterByName="astrosite_id"
                filter={filter}
                setFilter={setFilter}
                active={filter.astrosite_id ? true : false}
              />
            )
          }
          sortControl={
            filter && (
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"astrosite_id"}
              />
            )
          }
        >
          Astrosite
        </TableHeader>
        {advancedMode && (
          <TableHeader
            sortControl={
              filter && (
                <SortHeader
                  setFilter={setFilter}
                  filter={filter}
                  sortBy={"id"}
                />
              )
            }
          >
            ID
          </TableHeader>
        )}
        {/*Actions*/}
        <TableHeader />
      </TableHeaderRow>
      {schedules && (
        <tbody>
          {schedules.map(
            (schedule) =>
              schedule && (
                <Row key={schedule.id} zebra>
                  <Cell onClick={navigateTo(schedule.id)}>
                    <Timestamp utc={advancedMode} columnMode={true}>
                      {schedule.created}
                    </Timestamp>
                  </Cell>
                  <Cell>
                    <AstrositeName astrositeId={schedule.astrosite} />
                  </Cell>
                  {advancedMode && (
                    <Cell>
                      <IDCopy
                        truncateTo={20}
                        id={schedule.id}
                        showCopy={true}
                      />
                    </Cell>
                  )}
                  <Cell>
                    <Link to={`/schedules/${schedule.id}`}>Detail</Link>
                  </Cell>
                </Row>
              )
          )}
        </tbody>
      )}
    </Table>
  )
}

SchedulesTable.propTypes = {
  schedules: PropTypes.array, // the rsos to render
  filter: PropTypes.object, // If provided will be used to power the filters if not filters will not be shown
  setFilter: PropTypes.func, // If provided will be used to power the filters if not filters will not be shown
}

export default SchedulesTable
